import { formatDate } from '../lib/format.ts';

/**
 * Chama a atenção para o que a coleta mais recente atualizou. Não tem prazo próprio: some quando
 * uma coleta mais nova existe e não cobre aquela seção (a regra está em useCollections).
 */
export function NewBadge({ date }: { date: string }) {
  const label = `Atualizado na coleta de ${formatDate(date)}, a mais recente`;
  return (
    <span className="badge badge-new" title={label} aria-label={label}>
      Novo
    </span>
  );
}
